const baseClass = "syndicated-image";

const Image = ({
	name = "",
	isPromo = false,
	role = null,
	image: {
		id,
		url = "",
		title = "",
		alt = title,
		width = null,
		height = null,
		loading = "lazy",
	} = {},
}) => {
	const modifier = name ? `${baseClass}--${name}` : "";

	if (!url) {
		return null;
	}

	return (
		<img
			id={id}
			className={`${baseClass} ${modifier}`}
			src={url}
			alt={title || alt}
			title={title}
			aria-hidden={isPromo ? true : null}
			width={width}
			height={height}
			loading={loading}
			role={role && !isPromo ? role : null}
		/>
	);
};

export default Image;
